
  import React, { useState, useEffect } from 'react';
  import { Box, Modal, Button, List, ListItem, ListItemText, InputBase, IconButton } from '@mui/material';
  import { DataGrid } from '@mui/x-data-grid';
  import SearchIcon from '@mui/icons-material/Search';
  import { useTheme } from '@mui/material/styles';
  import LoadingSpinner from "../../loadingSpinner";
  import { tokens } from '../../theme';
  import ModalSucces from '../modalSucces';
  import ModalError from '../modalError';
  import { PostDatosOrdenProduccion, getUltimaOrden, getVerificarStock, PutActualizarReservas } from "../../services/ordenProduccion.services";
import secureStorage from "../../utils/secureStorage";
  
  const ModalStock = ({ open, onClose, registro }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [registrationSuccess, setRegistrationSuccess] = useState(null);
    const [productos, setProductos] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [ultimaOrden, setUltimaOrden] = useState("");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const User = secureStorage.getItem("id");
  
    
    const columns = [
      { field: "id", headerName: "ID", flex: 1 },
      { field: "cod", headerName: "Codigo", flex: 2 },
      { field: "cantidad_entrada", headerName: "Cantidad", flex: 1 },
      { field: "reservado", headerName: "Reservados", flex: 1 },
    ];
  
    useEffect(() => {
      if (open) {
        setIsLoading(true);
        fetchUltimaOrden();
        fetchProductos().finally(() => setIsLoading(false));
      }
    }, [open]);
  
    const fetchUltimaOrden = async () => {
      try {
        const response = await getUltimaOrden();
        setUltimaOrden(response[0]?.orden + 1 || "");
      } catch (err) {
        console.error("Error obteniendo la última orden", err);
      }
    };
  
    const fetchProductos = async () => {
      try {
        const response = await getVerificarStock(registro.descripcion_producto);
        setProductos(response);
        setFilteredData(response);
      } catch (error) {
        console.error("Error al obtener datos del backend:", error);
      }
    };
  
    const handleAceptar = async () => {
      setIsLoading(true);
      const { orden = ultimaOrden, id_producto, cantidad, id_fase, proceso } = registro;
      const estado = 1;
      const valuesToSend = {
        orden,
        id_producto,
        cantidad,
        estado,
        id_fase: id_fase || 1, // Asegúrate de que id_fase tenga un valor por defecto si no se proporciona
        proceso, // Asegúrate de que proceso tenga un valor por defecto si no se proporciona
      };


      try {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        await PostDatosOrdenProduccion(valuesToSend);

        productos.forEach(async (producto) => {
          const { cod } = producto; // Extrae el 'cod' de cada producto

          const cantidadActualizada = cantidad; // Usa la cantidad enviada en 'valuesToSend'
    
          // Llama a tu función para actualizar el stock
          // await PutActualizarReservas(cod, cantidadActualizada);
        });

        setRegistrationSuccess(true);
        setTimeout(() => {
          onClose();
        }, 3000);
        fetchProductos();
      } catch (error) {
        console.error("Error enviando datos", error);
        setRegistrationSuccess(false);
      } finally {
        setIsLoading(false);
        fetchUltimaOrden();
      }
    };
  
    const handleCancelar = () => {
      onClose();
    };
  
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-stock-title"
        aria-describedby="modal-stock-description"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: colors.primary[600],
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '800px',
            width: '90%',
            boxSizing: 'border-box',
          }}
        >
          {/* Mostrar LoadingSpinner si isLoading es true */}
          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
              <LoadingSpinner />
            </Box>
          ) : (
            <>
              {registrationSuccess && (
                <ModalSucces
                  open={registrationSuccess}
                  onClose={() => setRegistrationSuccess(null)}
                />
              )}
              {registrationSuccess === false && (
                <ModalError
                  open={!registrationSuccess}
                  onClose={() => setRegistrationSuccess(null)}
                  error="Error al guardar el registro"
                />
              )}
              <h2 style={{ color: colors.grey[100], marginBottom: '20px' }}>STOCK</h2>
{/*   
              <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <InputBase
                  value={searchValue}
                  onChange={handleSearchChange}
                  placeholder="Buscar producto"
                  sx={{
                    backgroundColor: colors.primary[500],
                    borderRadius: '8px',
                    padding: '5px 10px',
                    flexGrow: 1,
                    marginRight: '10px',
                    color: colors.grey[100],
                  }}
                />
                <IconButton>
                  <SearchIcon style={{ color: colors.grey[100] }} />
                </IconButton>
              </Box>
   */}
              <div style={{ height: 400, width: '100%' }}>
                <DataGrid
                  rows={filteredData}
                  columns={columns}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  sx={{
                    backgroundColor: colors.primary[500],
                    color: colors.grey[100],
                    borderColor: colors.grey[100],
                  }}
                />
              </div>
  
              <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <Button variant="contained" color="success" onClick={handleAceptar}>
                  Aceptar
                </Button>
                <Button variant="outlined" color="error" onClick={handleCancelar}>
                  Cancelar
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    );
  };
  
  export default ModalStock;
  